import { Select } from "antd";

const { Option } = Select;
export const LanguageAndCurrency = (props) => {
  const { language, handleLanguageChange, currency, handleCurrencyChange, t } =
    props;
  return (
    <div className="sticky-dropdowns flex-direction-column select-language-wrapper">
      <Select
        value={language}
        onChange={handleLanguageChange}
        bordered={false}
        style={{ width: 150 }}
      >
        <Option value="en">🇺🇸 {t("English")}</Option>
        <Option value="vi">🇻🇳 {t("Vietnamese")}</Option>
        <Option value="ko">🇰🇷 {t("Korean")}</Option>
        <Option value="zh">🇨🇳 {t("Chinese")}</Option>
        <Option value="ja">🇯🇵 {t("Japanese")}</Option>
      </Select>

      <Select
        defaultValue={currency}
        onChange={handleCurrencyChange}
        bordered={false}
        style={{ width: 150 }}
      >
        <Option value="USD">$ USD</Option>
        <Option value="VND">₫ VND</Option>
        <Option value="EUR">€ EUR</Option>
        <Option value="JPY">¥ JPY</Option>
        <Option value="CNY">¥ CNY</Option>
        <Option value="KRW">₩ KRW</Option>
        <Option value="THB">฿ THB</Option>
      </Select>
    </div>
  );
};
